/**
 * Stores an item in session storage with optional JSON serialization.
 *
 * @param {string} key - The session storage key to store the value under
 * @param {*} value - The value to store (will be JSON stringified if isJson is true)
 * @param {boolean} [isJson=false] - Whether to JSON stringify the value before storing
 */
export function setItem(key, value, isJson = false) {
    window?.sessionStorage?.setItem(key, isJson ? JSON.stringify(value) : value);
}

/**
 * Retrieves an item from session storage with optional JSON parsing.
 *
 * @param {string} key - The session storage key to retrieve
 * @param {boolean} [isJson=false] - Whether to attempt JSON parsing of the value
 * @returns {*} The retrieved value. If isJson is true and parsing fails, returns null
 */
export function getItem(key, isJson = false) {
    const value = window?.sessionStorage?.getItem(key);

    if (!value || !isJson) return value;

    try {
        return JSON.parse(value);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error parsing JSON from sessionStorage', error);
        // Return null for invalid JSON instead of the original string
        // This provides consistent behavior and prevents unexpected data types
        return null;
    }
}

/**
 * Removes an item from session storage.
 *
 * @param {string} key - The session storage key to remove
 */
export function removeItem(key) {
    window?.sessionStorage?.removeItem(key);
}

/**
 * Clears all items from session storage.
 * Use with caution as this will remove all session storage data for the current origin.
 */
export function clear() {
    window?.sessionStorage?.clear();
}
